import {Day} from '../DayList';

export const getActiveWeek = (weeks: Day[][], selectedDate: string) => {
  for (const [weekIndex, week] of weeks.entries()) {
    for (const day of week) {
      if (day.date === selectedDate) {
        return weekIndex;
      }
    }
  }
};
